module.exports = __webpack_public_path__ + "static/img/wxOauthLogin.cbdc735.gif";


//////////////////
// WEBPACK FOOTER
// ./static/wxOauth/wxOauthLogin.gif
// module id = 1204
// module chunks = 18